import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const FullscreenIcon: FC<Props> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      role="img"
      aria-labelledby="titleId"
      {...props}
     aria-label="fullscreen icon">
      {/* <title>fullscreen icon</title> */}
      <path
        d="M7.88562 2.3999H3.77133C3.01319 2.3999 2.3999 3.01319 2.3999 3.77133V7.88562C2.3999 8.64376 3.01319 9.25705 3.77133 9.25705C4.52947 9.25705 5.14276 8.64376 5.14276 7.88562V5.14276H7.88562C8.64376 5.14276 9.25705 4.52947 9.25705 3.77133C9.25705 3.01319 8.64419 2.3999 7.88562 2.3999ZM20.2285 2.3999H16.1142C15.356 2.3999 14.7428 3.01319 14.7428 3.77133C14.7428 4.52947 15.356 5.14276 16.1142 5.14276H18.857V7.88562C18.857 8.64376 19.4703 9.25705 20.2285 9.25705C20.9866 9.25705 21.5999 8.64376 21.5999 7.88562V3.77133C21.5999 3.01319 20.987 2.3999 20.2285 2.3999ZM7.88562 18.857H5.14276V16.1142C5.14276 15.356 4.52947 14.7428 3.77133 14.7428C3.01319 14.7428 2.3999 15.356 2.3999 16.1142V20.2285C2.3999 20.9866 3.01319 21.5999 3.77133 21.5999H7.88562C8.64376 21.5999 9.25705 20.9866 9.25705 20.2285C9.25705 19.4703 8.64419 18.857 7.88562 18.857ZM20.2285 14.7428C19.4703 14.7428 18.857 15.356 18.857 16.1142V18.857H16.1142C15.356 18.857 14.7428 19.4703 14.7428 20.2285C14.7428 20.9866 15.356 21.5999 16.1142 21.5999H20.2285C20.9866 21.5999 21.5999 20.9866 21.5999 20.2285V16.1142C21.5999 15.3556 20.987 14.7428 20.2285 14.7428Z"
        fill={props.fill || "currentColor" || "#F5F5F5"}
      />
    </svg>
  );
};

export default FullscreenIcon;
